/**
 * "10% off", over a listing photo.
 *
 * One component because there were three copies of the markup — the product
 * page's gallery and both listing thumbs — carrying the same string of a dozen
 * utility classes. Every change to the badge had to be made in three places,
 * which is the arrangement that lets them drift.
 *
 * The two halves are sized differently on purpose: the number is what the
 * reader is looking for and the word is what makes it a sentence, so "off" is
 * set smaller and sits on the number's baseline.
 */
const PercentOffBadge = ({
  percentOff,
  testId,
}: {
  percentOff: React.ReactNode;
  testId?: string;
}) => (
  <div
    className="absolute top-2 right-2 z-[3] flex items-baseline gap-1 rounded-full bg-orange-500 px-2.5 py-1 leading-none text-white shadow-lg"
    data-testid={testId}
  >
    <span className="text-base font-bold">{percentOff}%</span>
    <span className="text-xs font-semibold">off</span>
  </div>
);

export default PercentOffBadge;
